
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWrench as ObiWrenchElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-wrench.js';
 
 
 

 
 export const ObiWrench = createComponent({
   react: React,
   tagName: 'obi-wrench',
   elementClass: ObiWrenchElement,
   events: {
     
   }
  });
 
 